import { render, staticRenderFns } from "./contact-path-setting.vue?vue&type=template&id=8d7e7468&scoped=true&lang=html"
import script from "./contact-path-setting.vue?vue&type=script&lang=js"
export * from "./contact-path-setting.vue?vue&type=script&lang=js"
import style0 from "./contact-path-setting.vue?vue&type=style&index=0&id=8d7e7468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7e7468",
  null
  
)

export default component.exports